import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import { useCreateTrainingClassMembership } from 'modules/trainings/hooks/TrainingClassMemberships/useCreateTrainingClassMembership'

export const AddParticipantsToClassModal = ({ employeeIds }: { employeeIds: number[] }) => {
  const { navigation } = useNavigation()
  const { id, classId } = useParams()
  const navigate = useNavigate()
  const { company } = useCurrentSession()
  const { createTrainingClassMemberships } = useCreateTrainingClassMembership()

  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>(
    []
  )

  const onSubmit = async () => {
    const result = await createTrainingClassMemberships({
      trainingClassIds: [Number(classId)],
      employeeIds: selectedEmployees.map((employee) => employee.id),
      companyId: company.id,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.error'
        ),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.success_add'
        ),
      })
    }
    navigate(
      navigation.trainings.list.details_revamp.view.trainingClasses.detail.participants.fullPath({
        id: Number(id),
        classId: Number(classId),
      })
    )
  }

  return (
    <Modal
      title={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.title'
      )}
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.description'
      )}
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.trainingClasses.detail.participants.fullPath(
            { id: Number(id), classId: Number(classId) }
          )
        )
      }
    >
      <Box padding="s24" gap="s16">
        <EmployeeSelector
          alwaysOpen
          onSelect={setSelectedEmployees}
          multiple
          value={selectedEmployees}
          excludeIds={employeeIds}
        />
        <Button onClick={onSubmit}>
          {i18n.t('trainings.trainings_revamp.classes_sidepanel.participants.datatable.select')}
        </Button>
      </Box>
    </Modal>
  )
}
